import { Injectable } from '@angular/core';
import { signal } from '@angular/core';
import { Tenant } from '../models/matwins-tenant/Tenant.model';
import { PointOfService } from '../models/matwins-tenant/PointOfService.model';

@Injectable({
  providedIn: 'root'
})
export class CurrentTenantService {
  currentTenant = signal<Tenant | null>(null);
  currentClientId = signal<string>('');
  currentPointOfServiceId = signal<number | null>(null);
  currentPointOfService = signal<PointOfService | null>(null, {
    equal: (a, b) => a?.id === b?.id
  });
}
